import React, { useEffect, useState } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/news.png';
import { Wrapper } from './Landing';
import styled from 'styled-components/macro';
import Parser from 'rss-parser';
import Spinner from '../components/Spinner';
import imgNews from '../assets/img/news.svg';

const Feeds = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Feed = styled.a`
  display: block;
  width: 300px;
  min-height: 300px;
  height: auto;
  overflow: hidden;
  padding: 12px;
  margin: 12px;
  box-sizing: border-box;
  border: 1px solid #97b5b580;

  &:hover {
    border: 1px solid #4bc5c7;
  }

  &:link,
  &:visited {
    color: inherit;
  }

  & .title {
    font-weight: bold;
    font-size: 1.6em;
    margin-bottom: 1.1em;
    text-align: center;
  }

  & .caption {
    margin-top: 1.1em;
    text-align: center;
  }
`;

const News = () => {
  const [loading, setLoading] = useState(true);
  const [feeds, setFeeds] = useState([]);

  useEffect(() => {
    document.title = 'Emprouen Advisors: News';
  }, []);

  useEffect(() => {
    (async () => {
      const parser = new Parser();
      let feeds = { items: [] };
      try {
        feeds = await parser.parseURL('https://medium.com/feed/@lee_28163');
      } catch (e) {
        console.error(e);
      }

      console.log(feeds);

      setFeeds(
        feeds.items
          .map(feed => {
            const xmlParser = new DOMParser();
            let doc;
            if (feed.hasOwnProperty('content:encoded')) {
              doc = xmlParser.parseFromString(
                `<div>${feed['content:encoded']}</div>`,
                'text/xml'
              );
            }

            if (feed.hasOwnProperty('content')) {
              doc = xmlParser.parseFromString(
                `<div>${feed.content}</div>`,
                'text/xml'
              );
            }

            const captionElem = doc.querySelector('figcaption');
            const imgElem = doc.querySelector('img');
            return {
              ...feed,
              caption:
                feed.contentSnippet || (captionElem && captionElem.innerHTML),
              image: imgElem && imgElem.getAttribute('src')
            };
          })
          .concat([
            {
              title: 'Getting a Head Start',
              link: 'https://mjbizmagazine.com/getting-a-head-start/',
              image:
                'https://mjbizmagazine.com/wp-content/uploads/2020/06/FEAT-3-head-start.png'
            }
          ])
      );

      setLoading(false);

      setTimeout(window.syncHeight, 150);
    })();
  }, []);

  return (
    <Wrapper style={{ minHeight: 700 }}>
      <PageGraphic src={imgGrpahic} />
      <div>
        <h2>News</h2>

        {loading && <Spinner />}

        {!loading && (
          <Feeds>
            {feeds.map((feed, idx) => {
              return (
                <Feed
                  key={idx}
                  href={feed.link}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <div className="title">{feed.title}</div>
                  <img alt="Blog" src={feed.image || imgNews} />
                  {feed.caption && (
                    <div className="caption">{feed.caption}</div>
                  )}
                </Feed>
              );
            })}

            {!feeds.length && (
              <div>Check back later for news about Emprouen Advisors</div>
            )}
          </Feeds>
        )}
      </div>
    </Wrapper>
  );
};

export default News;
